import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { OrganizationProcessMetricsResponse } from '~/types/common';
import { dashboardOrganizationApi } from '~/utils/api';

export const insertWorkspace = async (organizationId: string, name: string) =>
  dashboardOrganizationApi.post<RcInstanceDTO.Workspace>(
    `/organizations/${organizationId}/workspaces`,
    {
      name,
      short_name: '',
    },
  );

export const getOneById = async (organizationId: string) =>
  dashboardOrganizationApi.get<RcInstanceDTO.Organization>(`/organizations/${organizationId}`);

export const deleteOneById = async (organizationId: string) =>
  dashboardOrganizationApi.delete<RcInstanceDTO.Organization>(`/organizations/${organizationId}`);

export const editOneById = async (
  organizationId: string,
  organization: RcInstanceDTO.Organization,
) =>
  dashboardOrganizationApi.put<RcInstanceDTO.Organization>(`/organizations/${organizationId}`, {
    ...organization,
  });

export const editConfigById = async (
  organizationId: string,
  config: RcInstanceDTO.OrganizationConfiguration,
) =>
  dashboardOrganizationApi.put<RcInstanceDTO.Organization>(
    `/organizations/${organizationId}/config`,
    {
      ...config,
    },
  );

export const inviteUser = async (
  organizationId: string,
  { email, realmId }: { email: string; realmId: string | undefined },
) =>
  dashboardOrganizationApi.post<RcInstanceDTO.OrganizationInvitation>(
    `/organizations/${organizationId}/invites`,
    {
      email,
      realmId,
    },
  );

export const getOrganizationOutgoingInvites = async ({
  organizationId,
  realmId,
}: {
  organizationId: string;
  realmId?: string;
}) =>
  dashboardOrganizationApi.get<RcInstanceDTO.OrganizationInvitation[]>(
    `/organizations/${organizationId}/invites`,
    realmId !== undefined ? { realmId } : undefined,
  );

export const getOrganizationMembers = async (organizationId: string) =>
  dashboardOrganizationApi.get<RcInstanceDTO.UserWithOrganizationRole[]>(
    `/organizations/${organizationId}/members`,
  );

export const removeOrganizationMember = async (organizationId: string, userId: string) =>
  dashboardOrganizationApi.delete<number>(`/organizations/${organizationId}/members/${userId}`);

export const deleteOrganizationInvite = async (organizationId: string, inviteId: string) =>
  dashboardOrganizationApi.delete<number>(`/organizations/${organizationId}/invites/${inviteId}`);

// TODO: fix return value
// dashboardOrganizationApi.delete<RcInstanceDTO.OrganizationInviteWithOrganization>(`/organizations/${organizationId}/invites/${inviteId}`);

export const listOrganizationRoles = async (organizationId: string) =>
  dashboardOrganizationApi.get<RcInstanceDTO.SimplifiedOrgRole[]>(
    `/organizations/${organizationId}/roles`,
  );

export const setOrganizationRole = async (organizationId: string, userId: string, roleId: string) =>
  dashboardOrganizationApi.put<RcInstanceDTO.UserWithOrganizationRole>(
    `/organizations/${organizationId}/members/${userId}/role`,
    { roleId },
  );

export const addWorkspaceMember = async (
  organizationId: string,
  workspaceId: string,
  userId: string,
) =>
  dashboardOrganizationApi.post<RcInstanceDTO.UserWithWorkspaceRole>(
    `/organizations/${organizationId}/workspaces/${workspaceId}/members`,
    { userId },
  );

export const setOrganizationInviteRole = async (
  organizationId: string,
  inviteId: string,
  roleId: string,
) =>
  dashboardOrganizationApi.put<RcInstanceDTO.OrganizationInvitation>(
    `/organizations/${organizationId}/invites/${inviteId}`,
    { roleId },
  );

export const updateDPA = async (organizationId: string, organization: RcInstanceDTO.Organization) =>
  dashboardOrganizationApi.post<RcInstanceDTO.Organization>(
    `/organizations/${organizationId}/dpa`,
    {
      ...organization,
    },
  );

export const getOrganizationProcessMetrics = async (organizationId: string) =>
  dashboardOrganizationApi.get<OrganizationProcessMetricsResponse>(
    `/organizations/${organizationId}/processes`,
  );
